export default __webpack_public_path__ + "static/media/40.677411e9.svg";